import backendRedirect from '../backendRedirect'
import {getDevServer, getDevServerRoot} from 'shared/js/devMode'

const defaultServerWithoutRoot = backendRedirect.apiTrafficManager
const devServerWithoutRoot = getDevServer('abbreviation', defaultServerWithoutRoot) // works b/c default -
const devServerRoot = getDevServerRoot('abbreviation') // - i.e. apiTrafficManager - has NO "path" (e.g. "/server")
const SERVER_ROOT = devServerRoot || '/api'
const SERVER = (devServerWithoutRoot || defaultServerWithoutRoot) + SERVER_ROOT
const internal = process.env.VUE_APP_INTERNAL === 'internal'

export const AppConfig = {
  SERVER_ROOT: SERVER_ROOT,
  SERVER: SERVER,
  SHOW_PASUK_FONT: true,
  USE_GENRE_CLASSIFICATION: false,
  TALMUD_GENRE: {
    INCLUDE: false,
    DEFAULT: false
  },
  PRE_SUBMISSION_OPTIONS_TO_SHOW: {
    ONLY_GENRE: false,
    ALL: false
  },
  OFFER_DROPBOX: internal, // for now
  SERVER_UPDATE: {
    ALWAYS_TRIGGER: false, // currently checked both before passing the callback AND before triggering update
    ALWAYS_USE: false, // like when running the nakdan in "talmud" mode
    BASE_URL: null,
    CONTENT_TYPE: 'str', // can be "str" or "json" -- currently hard-coded
    ENABLE_FULL_REFRESH: false
  },
  SPECIAL_AUTOSAVE_INTERVAL: null,
  NON_CONFIDENT_MARKING: internal,
  X_NEGATES_IN_BLIND: internal,
  OFFER_PINNING: internal,
  OFFER_CONDITIONAL_OPTIONS: internal,
  IN_KETIV_MALEH_AUTO_ADD_AIMS: false,
  PASSWORD_CHANGING: false
}
